import { render } from "./DocumentImageConfig.vue?vue&type=template&id=5d3464ad"
import script from "./DocumentImageConfig.vue?vue&type=script&lang=js"
export * from "./DocumentImageConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/flow/evaluate/DocumentImageConfig.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d3464ad"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d3464ad', __exports__)) {
    api.reload('5d3464ad', __exports__)
  }
  
  module.hot.accept("./DocumentImageConfig.vue?vue&type=template&id=5d3464ad", () => {
    api.rerender('5d3464ad', render)
  })

}


export default __exports__